import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MatDialogTitle, MAT_DIALOG_DATA } from '@angular/material';
import { PresentationEvent } from '../presentation';
import { PresentationSlide } from './presentation-slide';

@Component({
  selector: 'presentation-slide',
  template: `<div class="slide">
  <div class="slide__title" *ngIf="slide.title">
    <h1>{{slide.title}}</h1>
  </div>
  <div class="slide__content">
    <content-host [config]="slide.contentConfig"></content-host>
  </div>
  <div class="slide__actions">
    <div class="btn-group">
      <button *ngIf="hasPrevious" cuiButton color="gray-ghost" (click)="back()">
        <span class="icon-chevron-left"></span>
        <span>Back</span>
      </button>
      <button *ngIf="hasNext" cuiButton color="gray-ghost" (click)="next()">
        <span>Next</span>
        <span class="icon-chevron-right"></span>
      </button>
    </div>
    <button cuiButton color="negative" (click)="end()">End</button>
  </div>
</div>`,
  styles: [`.slide{position:relative;height:100%;width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.slide .slide__title{height:auto;-webkit-box-ordinal-group:2;-ms-flex-order:1;order:1}.slide .slide__content{position:relative;-webkit-box-flex:1;-ms-flex:1;flex:1;-webkit-box-ordinal-group:3;-ms-flex-order:2;order:2}.slide .slide__actions{position:absolute;bottom:0;left:50%;-webkit-transform:translate(-50%);transform:translate(-50%);padding:12px;z-index:+1}`]
})
export class PresentationSlideComponent implements OnInit {
  private _slide: PresentationSlide;
  private _hasNext: boolean;
  private _hasPrevious: boolean;

  constructor(
    public dialogRef: MatDialogRef<PresentationSlideComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this._slide = data.slide;
    this._hasNext = data.hasNext;
    this._hasPrevious = data.hasPrevious;
  }

  public ngOnInit(): void {

    // What for and handle certain key presses and trigger appropriate presentation behavior
    this.dialogRef.keydownEvents().subscribe((event: KeyboardEvent) => {
      switch (event.code) {
        case 'Escape':
          return this.end();
        case 'Space': case 'Enter': case 'ArrowRight':
          return this.next();
        case 'Backspace': case 'ArrowLeft':
          return this.back();
      }
    });
  }

  public get slide(): PresentationSlide { return this._slide; }
  public get hasNext(): boolean { return this._hasNext; }
  public get hasPrevious(): boolean { return this._hasPrevious; }

  public next(): void {
    if (this._hasNext) this.dialogRef.close(PresentationEvent.NEXT_SLIDE);
    else this.end();
  }

  public back(): void {
    if (this._hasPrevious) this.dialogRef.close(PresentationEvent.PREVIOUS_SLIDE);
    else this.end();
  }

  public end(): void { this.dialogRef.close(PresentationEvent.END); }

}
